export const laptops = [
  {
    img: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1661833895.57191049!256x256.jpg?f=webp",
    discount: 17,
    name: "Xiaomi Notebook Pro",
    price: "64,999",
  },
  {
    img: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1648710116.97884839!256x256.jpg?f=webp",
    discount: 32,
    name: "Mi Notebook Pro",
    price: "46,999",
  },
  {
    img: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1632911544.4955477!256x256.jpg?f=webp",
    discount: 11,
    name: "Mi Notebook 14",
    price: "41,999",
  },
  {
    img: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1650896467.04424744!256x256.jpg?f=webp",
    discount: 11,
    name: "Xiaomi Pad 5",
    price: "24,999",
  },
  {
    img: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1664774558.19975910!256x256.jpg?f=webp",
    discount: 11,
    name: "Redmi Pad",
    price: "14,999",
  },
  {
    img: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1648710116.97884839!256x256.jpg?f=webp",
    discount: 32,
    name: "Mi Notebook Pro",
    price: "46,999",
  },
  {
    img: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1632911544.4955477!256x256.jpg?f=webp",
    discount: 11,
    name: "Mi Notebook 14",
    price: "41,999",
  },
  {
    img: "https://i03.appmifile.com/526_item_in/10/06/2023/bae81fc259485c6a570c49a0588f1143!348x348.jpg?f=webp",
    discount: 32,
    name: "Xiaomi Pad 6",
    price: "26,999",
  },
];

export const laptopCarouselData = [
  {
    img: "https://i03.appmifile.com/637_operator_in/11/08/2023/a9451a3fb1334b01b75779b5569d52bf.jpg?f=webp",
    para1: "",
    name: "Redmi Pad",
    para2: "Binge Through Everything",
    price: "14,999"
  },
  {
    img: "https://i03.appmifile.com/443_operator_in/23/08/2023/687ab910f24ff9c41e7d78d169a12b86.jpg?f=webp",
    para1: "Do it Better",
    name: "Xiaomi Pad 6",
    para2: "Your Personal Theatre Experience",
    price: "26,999"
  }
]
